import { render, staticRenderFns } from "./Treats.vue?vue&type=template&id=0d0b0b64"
import script from "./Treats.vue?vue&type=script&lang=js"
export * from "./Treats.vue?vue&type=script&lang=js"
import style0 from "./Treats.vue?vue&type=style&index=0&id=0d0b0b64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports